export function linkToAdmin() {
  return "/admin";
}

export function linkToAdminDataExport() {
  return `${linkToAdmin()}/data-export`;
}

export function linkToAdminControlPanel() {
  return `${linkToAdmin()}/control-panel`;
}

export function linkToAdminBillingManagement() {
  return `${linkToAdmin()}/billing-management`;
}

export function linkToAdminFacilityManagement() {
  return `${linkToAdmin()}/facility-management`;
}

// ############ Investigations ############

export function linkToAdminInvestigations() {
  return `${linkToAdmin()}/investigations`;
}

export function linkToAdminInvestigationItemGenerator() {
  return `${linkToAdminInvestigations()}/item-generator`;
}
